import DataGridComponent from 'components/DataGrid/DataGridComponent';
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { MESSAGE_TYPE } from 'journeys/common/common.constants';
import { APIEndpoints } from 'helpers/APILists';
import _ from 'lodash';
import {
    securityGroupData, securityGroupApiEndpoint,
    searchDataInitialState, securityGroupInitialState
} from './SecurityGroup.data';

import SecurityGroupForm from './SecurityGroupForm';
import { customSort, trackErrors } from '../helper';
import { AdminConstants } from '../../AdminScreen.constants';

const addTitle = 'Add New Record for Security Groups';
const editTitle = 'Edit Record for Security Groups';

const SecurityGroup = () => {
    const apiEndpoints = securityGroupApiEndpoint;
    const [showModal, setShowModal] = useState(false);
    const [editRowData, setEditRowData] = useState(securityGroupInitialState);
    const [modalTitle, setModalTitle] = useState(addTitle);
    const [refreshDatagrid, setRefreshDatagrid] = useState(false);
    const [rowDetails, setRowDetails] = useState({
        columnName: 'RowId',
        rowNumber: '',
        refreshDatagrid: false
    });
    const [dropdownsData, setDropdownsData] = useState({
        bpRegionOptions: [],
        adGroupTypeIdOptions: [],
        roleIdOptions: [],
        bpRegionAliasNameOptions: []
    });

    useEffect(() => {
        fetchGroupMappings();
    }, []);

    const fetchGroupMappings = async () => {
        try {
            const res = await axios.get(APIEndpoints.GetMratGroupMappings);
            const liveRegionsList = _.uniq(res.data.filter(y => y.Status === AdminConstants.LIVE_STATUS).map(x => x.BpCompanyCodeName));
            setDropdownsData(prev => ({
                ...prev,
                bpRegionOptions: customSort(['ALL', ...liveRegionsList]),
                bpRegionAliasNameOptions: _.uniqWith(res.data.map(x => ({ BpRegion: x.BpCompanyCodeName, BpRegionAlias: x.BpRegionNameAlias })), _.isEqual)
            }));
        } catch (err) {
            trackErrors({
                messageType: MESSAGE_TYPE.ERROR,
                message: err.message,
                exception: err
            });
        }
    };

    const handleEditRecord = (obj) => {
        const rowData = obj.row;
        setModalTitle(editTitle);
        setShowModal(true);
        setEditRowData((prev) => ({
            ...prev,
            ...rowData
        }));
    };
    const handleAddRecord = () => {
        setEditRowData(securityGroupInitialState);
        setModalTitle(addTitle);
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
    };

    const handleRecordSubmit = (newId) => {
        setRowDetails(prev => ({ ...prev, rowNumber: newId }));
        setRefreshDatagrid(prev => !prev);
    };

    const parseData = async (data) => {
        try {
            const adGroupResponse = await axios.get(APIEndpoints.ADMIN_GetAdGroupType);
            const rolesResponse = await axios.get(APIEndpoints.ADMIN_GetRole);
            const result = data.map((res) => ({
                ...res,
                AdGroupType: adGroupResponse.data.find(x => x.AdGroupTypeId === res.AdGroupTypeId)?.Code,
                Role: rolesResponse.data.find(y => y.RoleId === res.RoleId)?.RoleName
            }));
            setDropdownsData(prev => ({
                ...prev,
                adGroupTypeIdOptions: _.sortBy(adGroupResponse.data.filter(y => y.Status === 'Active').map(x => ({
                    label: x.Code,
                    value: x.AdGroupTypeId
                })), 'label'),
                roleIdOptions: _.sortBy(rolesResponse.data.filter(y => y.Status === 'Active').map(x => ({
                    label: x.RoleName,
                    value: x.RoleId
                })), 'label')
            }));
            return result;
        } catch (err) {
            trackErrors({
                messageType: MESSAGE_TYPE.ERROR,
                message: err.message,
                exception: err
            });
            throw err;
        }
    };

    return (
        <>
            <DataGridComponent
                headerData={securityGroupData}
                apiEndpoint={apiEndpoints.read}
                editRecord={handleEditRecord}
                addRecord={handleAddRecord}
                initialData={searchDataInitialState}
                rowDetails={rowDetails}
                refreshDatagrid={refreshDatagrid}
                dataParser={parseData}
            />

            {showModal
                && (
                    <SecurityGroupForm
                        isOpen={showModal}
                        onClose={handleModalClose}
                        title={modalTitle}
                        rowData={editRowData}
                        onRecordSubmit={handleRecordSubmit}
                        dropdownsData={dropdownsData}
                    />
                )}
        </>
    );
};

export default SecurityGroup;
